import axiosInstance from "../Axiosinstance";
import { ENDPOINTS } from "../Endpoints";

class NotificationsService {
  async getNotifications(params = {}) {
    const res = await axiosInstance.get(ENDPOINTS.NOTIFICATIONS.FEED, { params });
    return res.data;
  }

  async getUnreadCount() {
    const res = await axiosInstance.get(ENDPOINTS.NOTIFICATIONS.UNREAD_COUNT);
    return res.data;
  }

  async markAsRead(notificationId) {
    const res = await axiosInstance.patch(
      `${ENDPOINTS.NOTIFICATIONS.FEED}/${notificationId}/read`
    );
    return res.data;
  }

  async markAllAsRead() {
    const res = await axiosInstance.patch(ENDPOINTS.NOTIFICATIONS.READ_ALL);
    return res.data;
  }
}

const notificationsService = new NotificationsService();
export default notificationsService;
